/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Age_Out_Of_RangeInputs */

const en_us2_body_assessment_age_out_of_range = /** @type {(inputs: Body_Assessment_Age_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The photo estimate is only available from age 15. Check your date of birth in your profile.`)
};

const pt_br2_body_assessment_age_out_of_range = /** @type {(inputs: Body_Assessment_Age_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A estimativa por foto só está disponível a partir dos 15 anos. Confira a sua data de nascimento no perfil.`)
};

const es_419_body_assessment_age_out_of_range = /** @type {(inputs: Body_Assessment_Age_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La estimación por foto solo está disponible a partir de los 15 años. Revisa tu fecha de nacimiento en el perfil.`)
};

const pt_pt2_body_assessment_age_out_of_range = /** @type {(inputs: Body_Assessment_Age_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A estimativa por fotografia só está disponível a partir dos 15 anos. Verifica a tua data de nascimento no perfil.`)
};

const fr_fr2_body_assessment_age_out_of_range = /** @type {(inputs: Body_Assessment_Age_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'estimation par photo n'est disponible qu'à partir de 15 ans. Vérifie ta date de naissance dans ton profil.`)
};

const de_de2_body_assessment_age_out_of_range = /** @type {(inputs: Body_Assessment_Age_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Schätzung per Foto gibt es erst ab 15 Jahren. Prüfe dein Geburtsdatum im Profil.`)
};

const it_it2_body_assessment_age_out_of_range = /** @type {(inputs: Body_Assessment_Age_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La stima da foto è disponibile solo dai 15 anni. Controlla la tua data di nascita nel profilo.`)
};

/**
* | output |
* | --- |
* | "The photo estimate is only available from age 15. Check your date of birth in your profile." |
*
* @param {Body_Assessment_Age_Out_Of_RangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_age_out_of_range = /** @type {((inputs?: Body_Assessment_Age_Out_Of_RangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Age_Out_Of_RangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_age_out_of_range(inputs)
	if (locale === "es-419") return es_419_body_assessment_age_out_of_range(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_age_out_of_range(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_age_out_of_range(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_age_out_of_range(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_age_out_of_range(inputs)
	return en_us2_body_assessment_age_out_of_range(inputs)
});
export { body_assessment_age_out_of_range as "body_assessment.age_out_of_range" }